import createVueComponent from '../createVueComponent';

const Clock6 = createVueComponent('Clock6Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 12 16.5' }],
]);

export default Clock6;
